import { useEffect, useRef, useState } from 'react'

/**
 * Copy-to-clipboard with a transient "done" flag.
 *
 * Split out of ui/CopyButton so the same behaviour -- including the failure
 * path, where a denied permission still shows feedback rather than nothing --
 * can back a compact in-row control as well as a full button.
 */
export function useCopy(resetMs = 2000): { copied: boolean; copy: (value: string) => Promise<void> } {
    const [copied, setCopied] = useState(false)
    const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

    useEffect(() => () => clearTimeout(timer.current), [])

    async function copy(value: string) {
        try {
            await navigator.clipboard.writeText(value)
        } catch {
            // denied or unavailable; still show feedback rather than nothing
        }
        setCopied(true)
        clearTimeout(timer.current)
        timer.current = setTimeout(() => setCopied(false), resetMs)
    }

    return { copied, copy }
}
